// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.b1bsY4RrZuIHSGvoSQVy{flex-direction:column;flex:1;gap:24px;max-width:100%;padding:16px 24px 24px;display:flex}.NvKpwFmPohUpkb9KCnCS{flex:1;justify-content:center;align-items:center;display:flex}.LU8IHuBYEFw3o_n0S51Y{flex-direction:column;gap:12px;display:flex}.kULA54nVLS0dColjRLee{flex-direction:column;flex:1;gap:32px;display:flex}.DEysnwfDqS02RKysM2RF{margin-left:-6px;margin-right:-6px}.C2MZE67klSktw3usEchh{flex:1;max-height:calc(100vh - 305px);overflow-y:auto}.ScRsNZpZdlQzILLQORcb{margin:15px 0 -10px}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"contentContainer": `b1bsY4RrZuIHSGvoSQVy`,
	"notFoundContainer": `NvKpwFmPohUpkb9KCnCS`,
	"detailsHeader": `LU8IHuBYEFw3o_n0S51Y`,
	"detailsTabs": `kULA54nVLS0dColjRLee`,
	"tabs": `DEysnwfDqS02RKysM2RF`,
	"tabContentWrapper": `C2MZE67klSktw3usEchh`,
	"invalidAlertContainer": `ScRsNZpZdlQzILLQORcb`
};
export default ___CSS_LOADER_EXPORT___;
